import { isPplDeliveryType } from "../../utils/isPplDeliveryType.js";
import type { Country } from "../Country.js";
import { DeliveryType } from "../DeliveryType.js";
import { countriesWithPplSupport } from "../countriesWithPplSupport.js";
import { personalPickupAddress } from "../personalPickupAddress.js";

export function getDeliveryTypesForCountry(country: Country): DeliveryType[] {
	return Object.values(DeliveryType).filter((type) => {
		if (type === DeliveryType.PersonalPickup) {
			return country === personalPickupAddress.country;
		}
		if (isPplDeliveryType(type)) {
			return countriesWithPplSupport.includes(country);
		}
		return true;
	});
}
